import { useState } from 'react';

const useSwitch = (props) => {
  const [checked, setChecked] = useState(props && props.checked ? props.checked : false);

  const onChange = (event, value) => {
    setChecked(!checked);
  };

  return {
    checked,
    onChange,
  };
};

export default useSwitch;
